import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SWRConfig } from 'swr';
import EngineLayout from './app/EngineLayout';
import { EngineSessionProvider } from './features/session/EngineSessionProvider';
import AuthCallbackPage from './pages/AuthCallbackPage';
import DocumentListPage from './pages/DocumentListPage';
import DocumentWorkspacePage from './pages/DocumentWorkspacePage';
import './app/engine-app.css';

const DeliveryEditorPrototype = lazy(() => import('./engine/DeliveryEditorPage'));

const App: React.FC = () => (
  <SWRConfig value={{ shouldRetryOnError: false, dedupingInterval: 1500 }}>
    <EngineSessionProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route element={<EngineLayout />}>
            <Route index element={<Navigate to="/documents" replace />} />
            <Route path="/documents" element={<DocumentListPage />} />
            <Route path="/documents/:documentId" element={<DocumentWorkspacePage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            <Route path="/prototype" element={
              <Suspense fallback={<div className="engine-app-workspace-skeleton" aria-label="正在打开交互原型" />}>
                <DeliveryEditorPrototype />
              </Suspense>
            } />
            <Route path="*" element={<Navigate to="/documents" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </EngineSessionProvider>
  </SWRConfig>
);

export default App;
